import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID, TransferState} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import * as dayjs from 'dayjs';
import 'dayjs/locale/sv';

import {ApiHelper} from './api.helper';
import {ToolsService} from './tools.service';
import {WPPageCustom} from '../types/WPPageCustom';
import {AppConfigService} from './app-config.service';

@Injectable()
export class StaticPagesService {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private tools: ToolsService,
    private appConfigService: AppConfigService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    dayjs.locale('sv');
  }

  public GetPage(id: number): Observable<WPPageCustom> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint = `${apiUrl}wp/pages/pages-${id}.json`;

    return this.http.get<WPPageCustom>(endpoint).pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public GetPageBySlug(slug: string): Observable<WPPageCustom> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint = `${apiUrl}wp/pages/pages-${slug}.json`;

    return this.http.get<WPPageCustom>(endpoint).pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public GetPagesByParentId(id: number): Observable<WPPageCustom[]> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint = `${apiUrl}wp/pages/pages-parent-${id}-page-1.json`;

    return this.http.get<WPPageCustom[]>(endpoint).pipe(catchError((error) => this.apiHelper.handleError(error, true)));
  }

  public getUpdateDateHtmlString(page: WPPageCustom): string {
    let updateDateString = '';
    if (
      !this.tools.isNil(page) &&
      !this.tools.isNil(page.content) &&
      page.content.rendered !== '' &&
      page.content.rendered !== 'null'
    ) {
      const updateDate: string = dayjs(page.modified).format('D MMMM YYYY');
      updateDateString = `<p><em>Senast uppdaterad: ${updateDate}</em></p>`;
    }
    return updateDateString;
  }
}
